module.exports = __webpack_public_path__ + "img/illu-claw.42488035.svg";